@charset "UTF-8";

/* src/app/shared/contract/contract-item/contract-thema-nego/thema-guaranteed-managing-dialog/thema-guaranteed-managing-dialog.component.scss */
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  margin: 0;
  border-radius: 5px;
  max-width: 920px;
  overflow-y: auto;
}
.title-container {
  justify-content: flex-start;
  font: 700 16px FranceTV Brown;
  margin-bottom: 10px;
}
.bloc-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.bloc-container-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  border-radius: 5px;
}
.bloc-container-row .bloc-container-pack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.bloc-container-row .bloc-container-channel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.inputs-container .input {
  flex-grow: 1;
}
.inputs-container-top {
  align-items: flex-start;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
.add-category-bloc-container {
  display: flex;
  gap: 10px;
  font: 400 14px FranceTV Brown;
  margin-left: 10px;
}
.add-category-bloc-container .type-icon {
  height: 16px;
}
.add-category-bloc-container .type-icon:hover {
  cursor: pointer;
}
.cond-container {
  max-height: 300px;
  overflow-y: auto;
}
.button-edit {
  justify-content: flex-end;
  display: inline-flex;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.container-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 450px;
  margin: 0;
  border-radius: 25px;
  font-size: 13px;
}
.container-options .mat-checkbox-inner-container {
  width: 12px;
  height: 12px;
}
.container-options .search-container {
  margin: 12px 0px;
}
.container-options .full-width {
  width: 100%;
}
.container-options .checkbox-list {
  display: flex;
  gap: 10px;
  flex-direction: column;
  max-height: 250px;
  overflow-y: auto;
  padding: 8px;
}
.container-options .button-group-horizontal {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.container-chips {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
  max-width: 905px;
}
.block-chip {
  display: flex;
  align-items: center;
  padding: 4px 7px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #6B90B3;
  color: #fff;
}
.block-chip .mat-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.block-chip .material-icons {
  font-size: 16px;
}
.block-chip .text {
  font-size: 12px;
  margin-right: 3px;
}
.condition-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.svg-delete-icon {
  width: 50px;
  height: 50px;
}
.content-position {
  align-items: center;
  width: 100%;
}
.all-option-button {
  margin-right: 10px;
}
.channel-logo {
  margin-right: 8px;
  width: 14px;
  height: auto;
}
.unit-label {
  padding: 0 10px 0 10px;
}
/*# sourceMappingURL=thema-guaranteed-managing-dialog.component.css.map */
